const tourCategories = [
  {
    id: "01",
    title: "Beaches and Islands",
    links: "sunandbeach",
    photo: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "A tropical beach with turquoise water",
  },
  {
    id: "02",
    title: "Hiking and Mountains",
    links: "hikingandtrekking",
    photo: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Mountain peaks beneath a clear sky",
  },
  {
    id: "03",
    title: "Wildlife and Safaris",
    links: "wildsafari",
    photo: "https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Wildlife on an African safari",
  },
  {
    id: "04",
    title: "Culture and Heritage",
    links: "cultural",
    photo: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Traditional architecture in Kyoto, Japan",
  },
  {
    id: "05",
    title: "Food and Local Experiences",
    links: "special",
    photo: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "A table of food to discover local cuisine",
  },
  {
    id: "06",
    title: "Festivals and Events",
    links: "festival",
    photo: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "A crowd enjoying a live outdoor event",
  },
];

export default tourCategories;
